import { Address4, Address6 } from 'ip-address';
import * as Long from 'long';

type IPType = 'IPv4' | 'IPv6';
const CommonRegEx = {
  IP_V4_CLASS_C_CIDR:
    /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(\/(2[4-9]|3[0-1]))$/
};
//TODO (Cristian): this is not a provider
export class IPHelper {
  static isIPv4(input: string, CIDR?: boolean): boolean {
    const IP4_STR =
      '((25[0-5]|(2[0-4]|1[0-9]|[1-9])?[0-9])(\\.(25[0-5]|(2[0-4]|1[0-9]|[1-9])?[0-9])){3})';

    const regExp = CIDR ? new RegExp('^' + IP4_STR + '\\/\\d+$') : new RegExp('^' + IP4_STR + '$');
    return regExp.test(input);
  }

  static isIPv6(input: string, CIDR?: boolean): boolean {
    const IP6_STR =
      '((([0-9a-fA-F]{1,4}:([0-9a-fA-F]{1,4}:([0-9a-fA-F]{1,4}:([0-9a-fA-F]{1,4}:([0-9a-fA-F]{1,4}:[0-9A-Fa-f]{0,4}|:[0-9a-fA-F]{1,4})?|(:[0-9a-fA-F]{1,4}){0,2})|(:[0-9a-fA-F]{1,4}){0,3})|(:[0-9a-fA-F]{1,4}){0,4})|:(:[0-9a-fA-F]{1,4}){0,5})((:[0-9a-fA-F]{1,4}){2}|:(25[0-5]|(2[0-4]|1[0-9]|[1-9])?[0-9])(\\.(25[0-5]|(2[0-4]|1[0-9]|[1-9])?[0-9])){3})|(([0-9a-fA-F]{1,4}:){1,6}|:):[0-9A-Fa-f]{0,4}|([0-9a-fA-F]{1,4}:){7}:)(-(([0-9a-fA-F]{1,4}:([0-9a-fA-F]{1,4}:([0-9a-fA-F]{1,4}:([0-9a-fA-F]{1,4}:([0-9a-fA-F]{1,4}:[0-9A-Fa-f]{0,4}|:[0-9a-fA-F]{1,4})?|(:[0-9a-fA-F]{1,4}){0,2})|(:[0-9a-fA-F]{1,4}){0,3})|(:[0-9a-fA-F]{1,4}){0,4})|:(:[0-9a-fA-F]{1,4}){0,5})((:[0-9a-fA-F]{1,4}){2}|:(25[0-5]|(2[0-4]|1[0-9]|[1-9])?[0-9])(\\.(25[0-5]|(2[0-4]|1[0-9]|[1-9])?[0-9])){3})|(([0-9a-fA-F]{1,4}:){1,6}|:):[0-9A-Fa-f]{0,4}|([0-9a-fA-F]{1,4}:){7}:))?)';

    const regExp = CIDR ? new RegExp('^' + IP6_STR + '\\/\\d+$') : new RegExp('^' + IP6_STR + '$');
    return regExp.test(input);
  }

  static isValidIP(input: string, CIDR?: boolean): boolean {
    return IPHelper.isIPv4(input, CIDR) || IPHelper.isIPv6(input, CIDR);
  }

  static getIPInfo(ip: string): { type: IPType; cidr: boolean } {
    if (IPHelper.isIPv4(ip, true)) {
      return { type: 'IPv4', cidr: true };
    }

    if (IPHelper.isIPv4(ip)) {
      return { type: 'IPv4', cidr: false };
    }

    if (IPHelper.isIPv6(ip, true)) {
      return { type: 'IPv6', cidr: true };
    }

    if (IPHelper.isIPv6(ip)) {
      return { type: 'IPv6', cidr: false };
    }
  }

  static getIPTransformer(ip: string): IPTransformer {
    const { type, cidr } = IPHelper.getIPInfo(ip);
    if (type === 'IPv4') {
      return new IPv4(ip, cidr);
    }
    if (type === 'IPv6') {
      return new IPv6(ip, cidr);
    }
  }

  static isValidIPv4ClassCCIDR(ip: string): boolean {
    return CommonRegEx.IP_V4_CLASS_C_CIDR.test(ip);
  }

  static isValidIpRange(entry: string): any {
    //check IPv4
    let beginAddr = new Address4(entry);
    let endAddr = null;
    let badRange = false;
    const addresses = entry.split('-');
    if (addresses.length > 1) {
      beginAddr = new Address4(addresses[0].trim());
      if (beginAddr.isValid()) {
        endAddr = new Address4(addresses[1].trim());
      } else {
        beginAddr = new Address6(addresses[0].trim());
        endAddr = new Address6(addresses[1].trim());
      }
      if (beginAddr.isValid() && endAddr.isValid()) {
        const bNum = beginAddr.bigInteger();
        const eNum = endAddr.bigInteger();
        badRange = bNum.compareTo(eNum) >= 0;
      }
    }

    const valid =
      (endAddr ? endAddr.isValid() : false) &&
      (beginAddr ? beginAddr.isValid() : false) &&
      !badRange;
    const parsedEndAddr =
      valid &&
      beginAddr.parsedSubnet &&
      beginAddr.endAddress().correctForm() !== beginAddr.startAddress().correctForm()
        ? beginAddr.endAddress().correctForm()
        : null;
    const parsedEndValue = valid && parsedEndAddr ? beginAddr.endAddress().bigInteger() : null;

    return {
      valid: valid,
      v4: valid && beginAddr.v4 && beginAddr.groups === 4,
      beginAddress: valid ? beginAddr.startAddress().correctForm() : null,
      beginValue: valid ? beginAddr.startAddress().bigInteger() : null,
      endAddress: valid && endAddr ? endAddr.correctForm() : parsedEndAddr,
      endValue: valid && endAddr ? endAddr.bigInteger() : parsedEndValue,
      error: {
        invalidAddress: !valid && !badRange,
        invalidRange: !valid && badRange
      }
    };
  }

  static getIPv4(ip: string): string {
    try {
      return new Address4(ip);
    } catch (err) {
      return null;
    }
  }
}

interface IPTransformer {
  toLong: () => LongIP;
  toRangeLong: () => Array<LongIP>;
}

interface LongIP {
  upper?: number;
  lower: number;
}

export class IPv6 implements IPTransformer {
  constructor(private ip_addr: string, private cidr: boolean) {}

  toLong(): LongIP {
    return this.convertToLong(this.ip_addr);
  }

  toRangeLong(): Array<LongIP> {
    return this.getRange().map(this.convertToLong.bind(this));
  }
  getRangeBasedOnCIDR(cidr: string): Array<number> {
    const ip_v6 = new Address6(cidr);
    return [ip_v6.startAddress().bigInteger(), ip_v6.endAddress().bigInteger()];
  }
  public intToIP(int: number): string {
    const ip_v6 = new Address6.fromBigInteger(int);
    return ip_v6.correctForm(ip_v6.address);
  }
  private getRange() {
    if (this.cidr) {
      const ip = new Address6(this.ip_addr);
      return [ip.startAddress().address, ip.endAddress().address];
    }
    return [this.ip_addr];
  }

  private convertToLong(ip_addr: string): LongIP {
    const ip_v6 = new Address6(ip_addr);
    return {
      upper: this.bitsToLong(ip_v6, 0, 64),
      lower: this.bitsToLong(ip_v6, 64, 128)
    };
  }
  // eslint-disable-next-line
  private bitsToLong(ip_v6: any, from: number, to: number): number {
    const bitsValues = ip_v6.getBits(from, to).toString();
    return Long.fromString(bitsValues).toString();
  }
}

export class IPv4 implements IPTransformer {
  constructor(private ip_addr: string, private cidr: boolean) {}

  toLong(): LongIP {
    return this.convertToLong(this.ip_addr);
  }

  toRangeLong(): Array<LongIP> {
    return this.getRange().map(this.convertToLong.bind(this));
  }
  // eslint-disable-next-line
  public getRange(): any {
    if (this.cidr) {
      const ip = new Address4(this.ip_addr);
      return [ip.startAddress().address, ip.endAddress().address];
    }
    return [this.ip_addr];
  }
  public intToIP(int: number): string {
    const ip_v4 = new Address4.fromInteger(int);
    return ip_v4.address;
  }

  private convertToLong(ip_addr: string): LongIP {
    const ip_v4 = new Address4(ip_addr);
    const bigInteger = ip_v4.bigInteger();
    return {
      lower: Long.fromNumber(bigInteger).toNumber()
    };
  }
}

export interface IpValidationResult {
  field: string;
  valid: boolean;
  message: string;
}
export class IPv4Validation {
  static ipToInt(ip: string): number {
    const parts = ip.split('.');
    if (parts.length !== 4) throw new Error('Invalid IPv4');
    if (parts.some(p => !/^\d+$/.test(p) || Number(p) < 0 || Number(p) > 255)) {
      throw new Error('Invalid IPv4 octet');
    }
    return parts.reduce((acc, o) => (acc << 8) + Number(o), 0) >>> 0;
  }

  static maskFromLength(length: number): number {
    if (length < 0 || length > 32) throw new Error('Invalid prefix length');
    return length === 0 ? 0 : (~0 << (32 - length)) >>> 0;
  }

  // Three bitwise checks: network bits all 1, host all 0, host all 1
  static isInvalidHost(addr: number, mask: number): boolean {
    const hostPart = ~mask >>> 0;

    const allNetworkBitsSet = (addr & mask) === mask; // network bits all 1
    const hostAllZeros = (addr & hostPart) === 0; // host bits all 0 → network
    const hostAllOnes = (addr & hostPart) === hostPart; // host bits all 1 → broadcast

    return allNetworkBitsSet || hostAllZeros || hostAllOnes;
  }

  static getValidSubnetRanges(ip1: string, ip2: string): { min: number; max: number } | null {
    const ip1Int = this.ipToInt(ip1);
    const ip2Int = this.ipToInt(ip2);
    const results: number[] = [];

    for (let prefix = 32; prefix >= 0; prefix--) {
      const mask = this.maskFromLength(prefix);
      if ((ip1Int & mask) === (ip2Int & mask)) results.push(prefix);
    }

    if (results.length === 0) return null;

    const filtered = results.filter(p => p >= 8); // optional minimum
    if (filtered.length === 0) return null;

    return { min: Math.min(...filtered), max: Math.max(...filtered) };
  }

  static validateIpv4AndGateway(
    testIp: string,
    gateway: string,
    prefixLength: number
  ): IpValidationResult {
    const testInt = this.ipToInt(testIp);
    const gwInt = this.ipToInt(gateway);
    const maskInt = this.maskFromLength(prefixLength);

    // Validate Subnet range
    const range = this.getValidSubnetRanges(testIp, gateway);
    if (range && (prefixLength < range.min || prefixLength > range.max)) {
      const errorMessage =
        range.min === range.max ? `Must be ${range.min}` : `Must be ${range.min} - ${range.max}`;
      return { field: 'subnet', valid: false, message: errorMessage };
    }

    // Validate Test IP
    if (this.isInvalidHost(testInt, maskInt)) {
      return { field: 'testIP', valid: false, message: 'Test IP cannot be network or broadcast.' };
    }

    // Validate Gateway
    if (this.isInvalidHost(gwInt, maskInt)) {
      return { field: 'gateway', valid: false, message: 'Gateway cannot be network or broadcast.' };
    }

    if (testInt === gwInt) {
      return {
        field: 'gateway',
        valid: false,
        message: 'Gateway IP cannot be the same as Test IP.'
      };
    }

    // Check if Gateway is in the same subnet
    const networkTest = testInt & maskInt;
    const networkGw = gwInt & maskInt;
    if (networkTest !== networkGw) {
      return {
        field: 'gateway',
        valid: false,
        message: 'Gateway is not in the same subnet as Test IP.'
      };
    }

    // Everything valid
    return { field: '', valid: true, message: 'Test IP, Gateway, and Subnet are valid.' };
  }
}

export class IPv6Validation {
  static parseIpv6(ip: string): number[] {
    const [head, tail = ''] = ip.split('::');
    const headParts = head
      .split(':')
      .filter(Boolean)
      .map(h => parseInt(h, 16));
    const tailParts = tail
      .split(':')
      .filter(Boolean)
      .map(t => parseInt(t, 16));
    const fillCount = 8 - headParts.length - tailParts.length;
    const fullParts = [...headParts, ...Array(fillCount).fill(0), ...tailParts];

    if (fullParts.length !== 8) throw new Error('Invalid IPv6 address');
    return fullParts; // 8 numbers (16-bit each)
  }

  static maskFromLength(prefixLength: number): number[] {
    if (prefixLength < 0 || prefixLength > 128) throw new Error('Invalid prefix length');
    const mask: number[] = Array(8).fill(0);
    let remaining = prefixLength;
    for (let i = 0; i < 8; i++) {
      if (remaining >= 16) {
        mask[i] = 0xffff;
        remaining -= 16;
      } else if (remaining > 0) {
        mask[i] = (~0 << (16 - remaining)) & 0xffff;
        remaining = 0;
      } else {
        mask[i] = 0;
      }
    }
    return mask;
  }

  static isInvalidHost(ip: number[], mask: number[]): boolean {
    for (let i = 0; i < 8; i++) {
      const hostPart = ~mask[i] & 0xffff;
      const hostBits = ip[i] & hostPart;
      const allOnesHost = hostBits === hostPart;
      const allZerosHost = hostBits === 0;
      const allNetworkOnes = (ip[i] & mask[i]) === mask[i];
      if (allNetworkOnes || allZerosHost || allOnesHost) return true;
    }
    return false;
  }

  static getValidSubnetMaxPrefix(ip1: number[], ip2: number[]): number {
    for (let prefix = 128; prefix >= 0; prefix--) {
      const mask = this.maskFromLength(prefix);
      let match = true;
      for (let i = 0; i < 8; i++) {
        if ((ip1[i] & mask[i]) !== (ip2[i] & mask[i])) {
          match = false;
          break;
        }
      }
      if (match) return prefix;
    }
    return 0;
  }

  static validateIpv6AndGateway(
    testIp: string,
    gateway: string,
    prefixLength: number
  ): IpValidationResult {
    const testArr = this.parseIpv6(testIp);
    const gwArr = this.parseIpv6(gateway);
    const maskArr = this.maskFromLength(prefixLength);

    const maxPrefix = this.getValidSubnetMaxPrefix(testArr, gwArr);
    if (prefixLength > maxPrefix)
      return { field: 'subnet', valid: false, message: `Subnet prefix must be <= ${maxPrefix}` };

    if (this.isInvalidHost(testArr, maskArr))
      return { field: 'testIP', valid: false, message: 'Test IP cannot be network or broadcast.' };

    if (this.isInvalidHost(gwArr, maskArr))
      return { field: 'gateway', valid: false, message: 'Gateway cannot be network or broadcast.' };

    if (testArr.join() === gwArr.join())
      return {
        field: 'gateway',
        valid: false,
        message: 'Gateway IP cannot be the same as Test IP.'
      };

    for (let i = 0; i < 8; i++) {
      if ((testArr[i] & maskArr[i]) !== (gwArr[i] & maskArr[i]))
        return {
          field: 'gateway',
          valid: false,
          message: 'Gateway is not in the same subnet as Test IP.'
        };
    }

    return { field: '', valid: true, message: 'Test IP, Gateway, and Subnet are valid.' };
  }
}
